$(document).ready(function() {

	// 全局页面进入loading
	function pageLoading() {
		setTimeout(function() {
			var index = layer.load(2, {shade: [0.1,'#fff']});
			setTimeout(function() {
				layer.close(index);
				$('.landing').css({'opacity': '1'});
			},500);
		},100);
	}
	pageLoading();

	// 隐藏导航
	var change = true;
	$('.download-inf').on('click','i',function () {
		if (change == true) {
			$('.download-box').addClass('hidden-right');
			$('.hidden-download').addClass('hidden-left')
			change = false;
		} else {
			$('.download-box').removeClass('hidden-right')
			$('.hidden-download').removeClass('hidden-left');
			change = true;
		}
	});

	$('.related-instructions .h2-tab').on('click','a',function () {
		$(this).addClass('select').siblings().removeClass('select').parent('.h2-tab').siblings('.content').children('.inf-box').eq($(this).index()).addClass('show').siblings().removeClass('show');
	});

	$('.navigation').on('click','li',function () {
		$(this).addClass('select').siblings().removeClass('select');
	});

	// 视频
	var Media = document.getElementById('media-play');
	$('.video').click(function(){
		var _src = $(this).attr('src');
		console.log(_src);
		$('#media-play').find('iframe').attr('src', _src);
		var index = layer.load(2, {shade: [0.1,'#fff']});
		setTimeout(function() {
			layer.close(index);
			$('.video-wrap').fadeIn();
		},500);
		// Media.play();
	})

	// 关闭
	$('.close').click(function(){
		$('.video-wrap').fadeOut();
		// Media.pause();
	})

	// 视频开始暂停
	var changeMedia = false;
	$('#media-play').click(function() {
		if (changeMedia) {
			Media.play();
			changeMedia = false;
		} else {
			Media.pause();
			changeMedia = true;
		}
	})

});

function index() {
	var swiper = new Swiper('.swiper-container', {
		autoplay:true,
		pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		on:{
			init: function(){
				swiperAnimateCache(this); //隐藏动画元素 
				swiperAnimate(this); //初始化完成开始动画
			}, 
			slideChangeTransitionEnd: function(){ 
				swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
				//this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
			} 
		}
	});
	var scene = document.getElementById('shake-box');
	var parallax = new Parallax(scene);
}

if(!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)){
	var wow = new WOW({ 
		boxClass: 'wow',
		animateClass: 'animated', 
		offset: 0, 
		mobile: true, 
		live: true 
	}); 
	wow.init();
}